import { resolve } from 'aurelia';
import { HttpServiceBase } from './http-service-base';
import { UserSession } from './user-session';


export class ApplicationLinksService extends HttpServiceBase {
  session = resolve(UserSession);

  save(referenceId, name, url, description) {
    let data = {
      referenceId: referenceId,
      name: name,
      url: url,
      description: description
    }

    return new Promise((resolve, reject) => {
      this.http.post('v1/applicationlinks', data)
        .then(httpMessage => JSON.parse(httpMessage.response))
        .then(data => resolve(data))
        .catch(e => {
          reject(e)
        });
    });
  }

  remove(id) {
    this.http.delete(`v1/applicationLinks/${id}`);
  }

  get(referenceId, name) {
    return new Promise((resolve, reject) => {
      this.http.get(`v1/applicationLinks?referenceId=${referenceId}&name=${name}`)
        .then(httpMessage => JSON.parse(httpMessage.response))
        .then(data => resolve(data))
        .catch(e => {
          reject(e)
        });
    })
  }
}
